import { render, staticRenderFns } from "./ModalClientBillingCard.vue?vue&type=template&id=054fd12c&scoped=true&"
import script from "./ModalClientBillingCard.vue?vue&type=script&lang=js&"
export * from "./ModalClientBillingCard.vue?vue&type=script&lang=js&"
import style0 from "./ModalClientBillingCard.vue?vue&type=style&index=0&id=054fd12c&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "054fd12c",
  null
  
)

export default component.exports